import styled from 'styled-components';

const Flag = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2); // Add shadow here
  display: inline-block;
`;

const stripeSize = '30%';

export const StyledSpanishFlag = styled(Flag)`
  background-color: #f4ca26;

  ::before {
    content: '';
    width: 100%;
    height: ${stripeSize};
    background-color: #b5343e;
    position: absolute;
    left: 0;
    top: 0;
  }

  ::after {
    content: '';
    width: 100%;
    height: ${stripeSize};
    background-color: #b5343e;
    position: absolute;
    left: 0;
    bottom: 0;
  }
`;

export const StyledFrenchFlag = styled(Flag)`
  background-color: white;

  ::before {
    content: '';
    height: 100%;
    width: ${stripeSize};
    background-color: #1177bc;
    position: absolute;
    left: 0;
    top: 0;
  }

  ::after {
    content: '';
    height: 100%;
    width: ${stripeSize};
    background-color: #b5343e;
    position: absolute;
    top: 0;
    right: 0;
  }
`;

export const StyledAllLanguagesFlag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
`;
